export const LANG_OPTIONS = {
	english: 'en',
	polish: 'pl',
	german: 'de',
	czech: 'cs',
};

export const LANGUAGE_CODES = Object.values(LANG_OPTIONS);
